/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */


/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */

import * as og    from 'og';
import * as SNAP_HELPER from './snap_helper.js';
let metaURL = new URL(import.meta.url);
        let imagesURL = metaURL.pathname.replace(/js.*/i, 'images');
let isCSSSupport_Has = CSS.supports("selector(:has(*))");
export class SnapGlobeResults {
    #options;
    #resultsId;
    #snapGlobe;
    #resultsLayer;
    #entityCollection;
    #template;
    #panel;
    #parser = new DOMParser();
    constructor(options = {}){
        this.#options = options;
        this.#resultsId = options['resultsId'] || 'sg-results';
        this.#snapGlobe = options['snapGlobe'];
        this.#init();
    }

    update(results = []) {
        this.clear();
        this.#resultsLayer.clear();
        if (!isCSSSupport_Has) {
            $(this.#panel).parent().css({'display': 'block'});
        }

        let newEntities = [];
        const template = document.querySelector("#tmpl-sg-item").content.querySelector("article");
        Array.prototype.forEach.call(results, (item, idx) => {
            let detailNode = template.cloneNode(true);
            let detailID = `sgItem${item.id}`;
            
            detailNode.setAttribute('id', `${detailID}`);
            detailNode.addEventListener('mouseenter', (e) => {
                e.preventDefault();
                e.stopPropagation();
                let lonLat = newEntities[idx].getLonLat().clone();
                lonLat.height = this.#snapGlobe.globe.planet.camera.getAltitude();
                this.#snapGlobe.globe.planet.flyLonLat(lonLat);
                newEntities[idx].billboard.setColorHTML('#0000FF');
            }, true);
            detailNode.addEventListener('mouseout', (e) => {
                e.preventDefault();
                newEntities[idx].billboard.setColorHTML(newEntities[idx].properties.color)
            }, true);
//            let detailNode = document.createElement('article');
//            detailNode.setAttribute('id', item.id);
//            detailNode.classList.add('sg-item');
            let detail = `<h5><a href='${item.ds_url}' title='${item.ds_alias}' target='_new'>${item.ds_alias}</a></h5>`;
            newEntities.push(this.#addBillboard(item.id,detailID, item.ds_position, item.ds_alias));
//            if (item.docs[0]) {

            //TIPS: item.docs || [], se docs è null allora usa un array vuoto per valutare comunque l'espressione
            let thumbs = Array.prototype.filter.call(item.docs || [], (doc) => {
                return doc.type == 'thumbnail';
            });
            let existsThumb = thumbs.length > 0;
            let moreThumbs = thumbs.length > 1;
//  
            if (existsThumb) {
                detail += '<div class="carousel-inner">';
                if (moreThumbs) {
                    detail += '<ol class="carousel-indicators" style="top:0;">';
                    Array.prototype.forEach.call(thumbs, (doc, idx) => {
                        detail += `<li data-target="#sgItem${item.id}" data-slide-to="sgItem${idx}" class="${idx === 0 ? "active" : ""}"></li>`;
                    });
                    detail += '</ol>';
                }
                Array.prototype.forEach.call(thumbs, (doc, idx) => {
                    detail += `
                              <figure class='carousel-item ${idx === 0 ? "active" : ""}'>
                                <div class="sg-thumbs">
                                <img src='/joomla/api/index.php/sg/catalog?what=${doc.name}' width=300 height=200 class='sg-thumbnail' />
                                <img src='/joomla/api/index.php/sg/catalog?what=${item.logo}' class='logo'/>
                                <!--figcaption title='${item.ds_alias}' >${item.ds_alias}</figcaption-->
                                </div>
                              </figure>
                            `;
                });
                if (moreThumbs) {
                    detail += `
                <a class="carousel-control-prev" style='width:fit-content;' href="#sgItem${item.id}" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" style='width:fit-content;' href="#sgItem${item.id}" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
                
            `;
                }
                detail += '</div>';
            } else {
                detail += `
                            <figure>
                              <div class='sg-thumbs'>
                                <img src='${imagesURL}/photo_300_200.png' width=300 height=200 class='sg-thumbnail'/>
                                <img src='/joomla/api/index.php/sg/catalog?what=${item.logo}' class='logo'/>
                              </div>
                              <figcaption>No preview available</figcaption>
                            </figure>`;
            }



            detailNode.innerHTML = detail;
            this.#panel.append(detailNode);
        });
        this.#resultsLayer.setEntities(newEntities);
        if (newEntities.length > 0) {
            let lonLat = newEntities[0].getLonLat().clone();
            lonLat.height = this.#snapGlobe.globe.planet.camera.getAltitude();
            this.#snapGlobe.globe.planet.viewLonLat(lonLat);
    }
    }

    clear() {

        this.#panel.innerHTML = '';
        this.#resultsLayer.clear();
        if (!isCSSSupport_Has) {
            $(this.#panel).parent().css({'display': 'none'});
        }
    }

    #addBillboard(id, detailId, point, what) {
        let billboard = new og.Entity({
            'name': what,
            'lonlat': point
                    .replace('POINT(', '').replace(')', '')
                    .split(' ')
                    .map((x) => parseFloat(x)),
            'billboard': {
                'src': `${imagesURL}/marker.png`,
                'size': [18, 32],
                'offset': [0, 16],
                'alignedAxis': og.wgs84.lonLatToCartesian([10, 30]).normalize(),
                'color': '#FFFFFF'
            },
            properties: {
                'name': what,
                'color': '#FFFFFF',
                'id': id,
                'detailId':detailId
            }
        });
        return billboard;
    }

    #init() {
        this.#panel = document.getElementById(this.#resultsId);

        this.#template = document.getElementById('tmpl-sg-item').content;

        let l = document.getElementById('sg-globus');

        document.getElementById('sg-results-clear').addEventListener("click",
                (e) => {
            e.preventDefault();
            this.clear();
            l.style.setProperty('height', '100%', 'important');

        }
        );
        this.#resultsLayer = new og.layer.Vector("pointLayer", {
            'clampToGround': true,
            'async': false
        });
        this.#resultsLayer.events.on("mouseenter", function (e) {
            console.log('enter');
            
            e.renderer.handler.canvas.style.cursor = "pointer";
            e.pickingObject.billboard.setColorHTML('#0000FF');
            let detailID = e.pickingObject.properties.detailId;
            document.location.href = `#${detailID}`;
//            e.pickingObject.billboard.setLabel("ASDADS");
        });
        this.#resultsLayer.events.on("mouseleave", function (e) {
            console.log('leave');
            e.renderer.handler.canvas.style.cursor = "default";
            e.pickingObject.billboard.setColorHTML(e.pickingObject.properties.color);
            
        });
        this.#resultsLayer.events.on("ldown", function (e) {
             console.log('down');
            e.renderer.controls.mouseNavigation.deactivate();
            let pickingObject = e.pickingObject;
            console.log(pickingObject.name);
        });
        this.#resultsLayer.events.on("lup", function (e) {
            console.log('up');
            e.renderer.controls.mouseNavigation.activate();
        });
        this.#resultsLayer.addTo(this.#snapGlobe.globe.planet);
        this.clear();


        /*Resize*/
        let resizeButton = document.getElementById('sg-resize-results-panel');
        /*Minimize*/
        let minimizeButton = document.getElementById('sg-minimize-results-panel');

        minimizeButton.addEventListener("click", (event) => {
                    l.classList.remove('sg-display-none');
                    l.removeAttribute('disabled', true);
        }, true);
        
//        let l = document.getElementById('sg-globus-section');

        let sidebar = document.getElementById('sg-sidebar');

        let height = window.outerHeight - l.offsetTop;
        let heightHalf = height / 2;


        let isDisplayed = (el) => {
            return !el.classList.contains('sg-display-none');
        };


        let main = document.getElementById('sg-globus-main');

        let delta = l.offsetTop - sidebar.offsetTop;

        let mmove = function (event) {
            event.preventDefault();
            event.stopPropagation();
            const touches = event.changedTouches;
            let py = touches ? touches[0].pageY : event.pageY;
            let o = Math.max(py - l.offsetTop, heightHalf);
            let v = Math.min(Math.ceil(100 * (o) / height), 100);
            window.requestAnimationFrame(() => {
                l.style.setProperty('height', `calc(${v}% - ${delta}px)`, 'important');
            });
        };
        resizeButton.addEventListener("click", (event) => {
            window.requestAnimationFrame(() => {
                if (isDisplayed(l)) {
                    l.classList.add('sg-display-none');
                    l.setAttribute('disabled', true);
                } else {
                    l.classList.remove('sg-display-none');
                    l.removeAttribute('disabled', true);
                }
            });
        }, true);
        resizeButton.addEventListener("dragstart", (event) => {
            console.log("Drag Start");

            if (isDisplayed(l)) {
                resizeButton.classList.add('sg-dragging');
                window.addEventListener("dragover", mmove, true);
            }
        }, true);
        resizeButton.addEventListener("dragend", (event) => {
            console.log("Drag End");
            resizeButton.classList.remove('sg-dragging');
            window.removeEventListener("dragover", mmove, true);
        }, true);
        
        resizeButton.addEventListener("touchstart", (event) => {
            console.log("Drag Start");
            if (isDisplayed(l)) {
                resizeButton.classList.add('sg-dragging');
                window.addEventListener("touchmove", mmove, true);
            }
        }, true);
        resizeButton.addEventListener("touchend", (event) => {
            console.log("Drag End");
            resizeButton.classList.remove('sg-dragging');
            window.removeEventListener("touchmove", mmove, true);
        }, true);
        resizeButton.addEventListener("touchcancel", (event) => {
            console.log("Drag End");
            resizeButton.classList.remove('sg-dragging');
            window.removeEventListener("touchmove", mmove, true);
        }, true);
    }
}
